
import axios from "./axiosinstance";
import { APIS, BASE_URL } from "../utils/apifactory";


export const registerApi = (data, callBack, error) => {
    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const requestBody = {
        data
    };

    axios.post(APIS.REGISTER_USER, data, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};
export const loginApi = (email,password, callBack, error) => {
    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const requestBody = {
        "email": email,
        "password": password
    };

    axios.post(APIS.LOGIN_API, requestBody, headerConfig)
        .then((res) => {
            const token = res.data.token;
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

// export const creatorApi = (token, callBack, error) => {
//     const headerConfig = {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `${token}`
//         },
//     };

//     axios.get(APIS.GET_CATEGORIES_API, headerConfig)
//         .then((res) => {
//             callBack(res.data);
//         })
//         .catch((err) => {
//             console.error("API Error:", err);
//             if (err.response) {
//                 callBack(err.response.data);
//             }
//         });
// };

// export const dicoverApi = (token, callBack, error) => {
//     const headerConfig = {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `${token}`
//         },
//     };

//     axios.get(APIS.GET_DISCOVER_LITING, headerConfig)
//         .then((res) => {
//             callBack(res.data);
//         })
//         .catch((err) => {
//             console.error("API Error:", err);
//             if (err.response) {
//                 callBack(err.response.data);
//             }
//         });
// };
export const creatorApi = (token, { category = '', page='' , validated = 'VALIDATED', country = '',searchTerm='' }, callBack, error) => {
    const url = `${APIS.GET_CATEGORIES_API}${category}&page=${page}&validated=${validated}&country=${country}&searchTerm=${searchTerm}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const dicoverApi = (token, { category = '', page , validated = 'VALIDATED', country = '' }, callBack, error) => {
    const url = `${APIS.GET_DISCOVER_LITING}${category}&page=${page}&validated=${validated}&country=${country}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};


export const getSelfieByIdNew = (token, id, callBack, error) => {
    const url = `${APIS.GET_SELFIES_BY_ID}${id}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const getSelfieById = (token, id, callBack, error) => {
    const url = `${APIS.GET_SELFIES_BY_ID}${id}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const addToCartApi = (token, data, callBack, error) => {
    const url = `${APIS.ADD_TO_CART_API}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.post(url,data, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};
export const changepasswordApi = (token, id, callBack, error) => {
    const url = `${APIS.CHANGE_PASSWORD_API}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.post(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const profileWishListApi = (token, callBack, error) => {
    const url = `${APIS.PROFILE_WISH_LIST_API}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const productWinApi = (token, id, callBack, error) => {
    const url = `${APIS.PRODUCT_WIN_API}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};
export const myPurchaseApi = (token, callBack, error) => {
    const url = `${APIS.MY_PURCHASE_API}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};
export const myImagesInprofile = (token, callBack, error) => {
    const url = `${APIS.MY_IMAGES_PROFILE}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const getItemDataById = (token, id, callBack, error) => {
    const url = `${APIS.GET_ITEMS_BY_ID}${id}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};
export const getCartDataApi = (token,callBack, error) => {
    const url = `${APIS.GET_CART_DATA}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const getSelfieLikeApi = (token, id, callBack, errorCallback) => {
    const url = `${APIS.GET_SELFIES_BY_ID}${id}/like`;
  
    const headerConfig = {
      headers: {
        Authorization: `${token}`,
      },
    };
  
    axios
      .post(url, null, headerConfig) 
      .then((res) => {
        callBack(res.data);
      })
      .catch((err) => {
        console.error("API Error:", err);
        if (err.response) {
          callBack(err.response.data);
        } else if (errorCallback) {
          errorCallback(err);
        }
      });
  };
export const getunSelfieLikeApi = (token, id, callBack, errorCallback) => {
    const url = `${APIS.GET_SELFIES_BY_ID}${id}/unlike`;

    const headerConfig = {
        headers: {
          Authorization: `${token}`,
        },
      };
    
      axios
        .post(url, null, headerConfig) 
        .then((res) => {
          callBack(res.data);
        })
        .catch((err) => {
          console.error("API Error:", err);
          if (err.response) {
            callBack(err.response.data);
          } else if (errorCallback) {
            errorCallback(err);
          }
        });
};

export const getProfileDataApi = (token,id, page,callBack, error) => {
    const url = `${APIS.GET_PROFILE_DATA}/${id}?page=${page}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};
export const getLikedDataApi = (token, callBack, error) => {
    const url = `${APIS.GET_LIKED_DATA}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};
export const getWinDataApi = (token, callBack, error) => {
    const url = `${APIS.GET_WIN_DATA}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const getFollowcountApi = (token,ID, callBack, error) => {
    const url = `${APIS.GET_FOLLOW_USERS_COUNT+ID}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const followUserApi = (token, userId, followerId, callback) => {
    fetch(BASE_URL+"/follows", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token
      },
      body: JSON.stringify({  follower_id: followerId ,user_id: userId,}),
    })
      .then(res => res.json())
      .then(data => callback(data))
      .catch(err => {
        console.error("Follow error:", err);
        callback(null);
      });
  };
  
  export const unfollowUserApi = (token, followId, callback) => {
    fetch(`${BASE_URL}/follows/user`, {
      method: "DELETE",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        target_id: followId,
      }),
    })
      .then((res) => res.json())
      .then((data) => callback(data))
      .catch((err) => {
        console.error("Unfollow error:", err);
        callback(null);
      });
  };
  
  export const getUserAddressApi = (token, callBack, error) => {
    const url = `${APIS.GET_ADDRESS_API}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};

export const updateUserProfileApi = (token,id, updatedFields, callback) => {
    fetch(BASE_URL+'/users'+'/'+id, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`
        },
        body: JSON.stringify(updatedFields)
    })
        .then(res => res.json())
        .then(data => callback(data))
        .catch(err => {
            console.error("Update error:", err);
            callback(null);
        });
};
export const getNoticationsApi = (token, callBack, error) => {
    const url = `${APIS.GET_NOTIFICATION}`;

    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        },
    };

    axios.get(url, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((err) => {
            console.error("API Error:", err);
            if (err.response) {
                callBack(err.response.data);
            }
        });
};
export const deleteNotificationApi = async (id, token, callback) => {
    try {
      const response = await axios.delete(`${BASE_URL}/notifications/user`, {
        data: { id },
        headers: {
          Authorization: token,
          "Content-Type": "application/json"
        }
      });
      callback(response.data);
    } catch (error) {
      callback({ success: false, error: error.message });
    }
  };
  
  export const getNotificationDetailApi = async (id, token, callback) => {
    try {
      const response = await axios.get(`${BASE_URL}/notifications/${id}`, {
        headers: {
          Authorization: token,
        }
      });
      callback(response.data);
    } catch (error) {
      callback({ success: false, error: error.message });
    }
  };
  